<template>
  <div>
    <wg-modal
      v-if="openPicker"
      :portal="true"
      :width="windowWidth > 700 ? '400px' : '90%'"
      @closeModal="openPicker = false"
    >
      <div slot="body">
        <world-date-picker
          v-if="isFrom"
          :from="
            $moment(sdInput)
              .utc()
              .format('X')
          "
          @customFunction="setDate"
        ></world-date-picker>
        <world-date-picker
          v-else
          :from="
            $moment(edInput)
              .utc()
              .format('X')
          "
          @customFunction="setDate"
        ></world-date-picker>
      </div>
    </wg-modal>
    <template v-if="layout === '1'">
      <div class="wg-row">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, "Name", "Nome") }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input
          class="com-anm22-app-input-text"
          style="max-width:100%;"
          type="text"
          :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
          v-model="event.name"
        />
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Start", "Inizio") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-7" style="padding:0 2px;">
              <div
                @click="
                  openPicker = !openPicker;
                  isFrom = true;
                "
                :class="[
                  'input-date-picker-label',
                  errors['start'] ? 'input-error' : '',
                ]"
              >
                {{ $moment(sdInput).format("DD-MM-YYYY") }}
              </div>
            </div>
            <div class="wg-col wg-xs-5" style="padding:0 2px;">
              <input
                :class="[
                  'com-anm22-app-input-time',
                  errors['start'] ? 'input-error' : '',
                ]"
                type="time"
                v-model.lazy="startTimeInput"
              />
            </div>
          </div>
        </div>
        <div class="wg-sm-none vertical-height-div" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "End", "Fine") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <div class="wg-col wg-xs-7" style="padding:0 2px;">
              <div
                @click="
                  openPicker = !openPicker;
                  isFrom = false;
                "
                :class="[
                  'input-date-picker-label',
                  errors['end'] ? 'input-error' : '',
                ]"
              >
                {{ $moment(edInput).format("DD-MM-YYYY") }}
              </div>
            </div>
            <div class="wg-col wg-xs-5" style="padding:0 2px;">
              <input
                :class="[
                  'com-anm22-app-input-time',
                  errors['end'] ? 'input-error' : '',
                ]"
                type="time"
                v-model.lazy="endTimeInput"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 2px;">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Timezone", "Fuso orario") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <select
            class="com-anm22-app-select"
            v-model="event.timezone"
            style="max-width:100%;"
          >
            <option
              v-for="(timezone,
              key,
              index) in $anm22.tableClasses.worldTimezone().getAll()"
              :key="'tz-' + index"
              :value="key"
            >
              {{ timezone[lang] }}
            </option>
          </select>
        </div>
        <!-- Fuso orario di arrivo solo se l'evento è un evento di viaggio - gestione ???? -->
        <div
          v-show="event.type == 2"
          class="wg-col wg-xs-12 wg-sm-6"
          style="padding:0 2px;"
        >
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Timezone", "Fuso orario") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <select
            class="com-anm22-app-select"
            v-model="timezoneArrival"
            style="max-width:100%;"
          >
            <option
              v-for="(timezone,
              key,
              index) in $anm22.tableClasses.worldTimezone().getAll()"
              :key="'tza-' + index"
              :value="key"
            >
              {{ timezone[lang] }}
            </option>
          </select>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 2px;">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Event type", "Tipologia evento") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <select
            class="com-anm22-app-select"
            v-model="eventType"
            style="max-width:100%;"
          >
            <option
              v-for="(type, index) in eventTypes"
              :key="'t-' + index"
              :value="type.typeClass"
            >
              {{ type[lang] }}
            </option>
          </select>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 2px;">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Kilometers", "Chilometri") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            :placeholder="$anm22.strLang(lang, 'Kilometers', 'Chilometri')"
            type="number"
            step="1"
            min="0"
            style="max-width:100%;"
            v-model="kilometers"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 2px;">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Event type", "Tipologia evento") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <select
            class="com-anm22-app-select"
            v-model="eventType"
            style="max-width:100%;"
          >
            <option
              v-for="(type, index) in eventTypes"
              :key="'t-' + index"
              :value="type.typeClass"
            >
              {{ type[lang] }}
            </option>
          </select>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row">
            <div class="wg-col wg-xs-7 wg-sm-7" style="padding:5px 2px;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "Start date", "Data inizio") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div
                @click="
                  openPicker = !openPicker;
                  isFrom = true;
                "
                :class="['input-date-picker-label']"
                style="max-width:100%;"
              >
                {{ $moment(sdInput).format("DD-MM-YYYY") }}
              </div>
            </div>
            <div class="wg-col wg-xs-5 wg-sm-5" style="padding:5px 2px;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "Time", "Ora") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <input
                class="com-anm22-app-input-date"
                style="max-width:100%;"
                type="time"
                v-model.lazy="startTimeInput"
              />
            </div>
            <div class="wg-col wg-xs-12 wg-sm-12" style="padding:5px 2px;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "Timezone", "Fuso orario") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <select
                class="com-anm22-app-select"
                v-model="event.timezone"
                style="max-width:100%;"
              >
                <option
                  v-for="(timezone,
                  key,
                  index) in $anm22.tableClasses.worldTimezone().getAll()"
                  :key="'tz-' + index"
                  :value="key"
                >
                  {{ timezone[lang] }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row">
            <div class="wg-col wg-xs-7 wg-sm-7" style="padding:5px 2px;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "End date", "Data fine") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div
                @click="
                  openPicker = !openPicker;
                  isFrom = false;
                "
                :class="['input-date-picker-label']"
                style="max-width:100%;"
              >
                {{ $moment(edInput).format("DD-MM-YYYY") }}
              </div>
            </div>
            <div class="wg-col wg-xs-5 wg-sm-5" style="padding:5px 2px;">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "Time", "Ora") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <input
                class="com-anm22-app-input-date"
                style="max-width:100%;"
                type="time"
                v-model.lazy="endTimeInput"
              />
            </div>
            <!-- Fuso orario di arrivo solo se l'evento è un evento di viaggio - gestione jsonData -->
            <div
              v-show="event.type == 2"
              class="wg-col wg-xs-12 wg-sm-12"
              style="padding:5px 2px;"
            >
              <div class="com-anm22-app-text-l">
                {{
                  $anm22.strLang(lang, "Arrival timezone", "Fuso orario arrivo")
                }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <select
                class="com-anm22-app-select"
                v-model="timezoneArrival"
                style="max-width:100%;"
              >
                <option
                  v-for="(timezone,
                  key,
                  index) in $anm22.tableClasses.worldTimezone().getAll()"
                  :key="'tza-' + index"
                  :value="key"
                >
                  {{ timezone[lang] }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="com-anm22-app-text-l" style="padding:0 2px;">
          {{ $anm22.strLang(lang, "Description", "Descrizione") }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <input
          class="com-anm22-app-input-text"
          style="max-width:100%;"
          type="text"
          :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
          v-model="event.name"
        />
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6" style="padding:0 2px;">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Kilometers", "Chilometri") }}
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <input
            class="com-anm22-app-input-text"
            :placeholder="$anm22.strLang(lang, 'Kilometers', 'Chilometri')"
            type="number"
            step="1"
            min="0"
            style="max-width:100%;"
            v-model="kilometers"
          />
        </div>
      </div>
    </template>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <input
        type="button"
        :class="[
          'small',
          Object.keys(errors).length > 0 ? 'button-disabled' : '',
        ]"
        :value="$anm22.strLang(lang, 'Save', 'Salva')"
        :disabled="Object.keys(errors).length > 0"
        @click="saveEvent"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import WorldDatePicker from "../../../../../world/spa/components/WorldDatePicker.vue";

export default {
  props: {
    projectId: [Number, String],
    eventRef: Object,
  },
  data() {
    return {
      isFrom: false,
      openPicker: false,
      event: { ...this.eventRef },
      additionalData:
        this.eventRef.jsonData && !Array.isArray(this.eventRef.jsonData)
          ? this.eventRef.jsonData
          : {},
      errors: {},
      // Collegamento viene fatto solo al salvataggio
      sd: "",
      sdInput: "",
      st: "",
      stInput: "",
      ed: "",
      edInput: "",
      et: "",
      etInput: "",
      removeTempTimeTracking: false,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    licenses() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser)
        .filter((e) => this.project.developers.includes(e.work))
        .map((e) => this.$store.getters["licenses/getByWork"](e.work))
        .filter((l) => l);
    },
    layout() {
      if (this.licenses.length > 0) {
        const l = this.licenses[0];
        if (
          l &&
          l.config.tasks &&
          l.config.tasks.events &&
          l.config.tasks.events["event-layout"]
        ) {
          return l.config.tasks.events["event-layout"];
        } else {
          return "1";
        }
      } else {
        return "1";
      }
    },
    eventTypes() {
      return [1, 2, 3].map((id) =>
        this.$anm22.tableClasses.worldEventType().getById(id)
      );
    },
    eventType: {
      get() {
        return this.event.type;
      },
      set(newVal) {
        this.event.type = newVal;
        if (
          this.event.type != 2 &&
          this.additionalData &&
          this.additionalData.timezoneArrival
        ) {
          this.$delete(this.additionalData, "timezoneArrival");
        } else {
          if (!(this.additionalData && this.additionalData.timezoneArrival)) {
            this.$set(
              this.additionalData,
              "timezoneArrival",
              this.event.timezone
            );
          }
        }
      },
    },
    startDate: {
      get() {
        return this.sd;
      },
      set: function(newDate) {
        this.sd = newDate;
        this.checkInputFields("f");
      },
    },
    startTime: {
      get() {
        return this.st;
      },
      set: _.debounce(function(newTime) {
        this.st = newTime;
        this.checkInputFields("f");
      }, 100),
    },
    startDateInput: {
      get() {
        return this.sd;
      },
      set: function(newDate) {
        // Controllo che sia nel formato giusto
        this.sdInput = this.$anm22.parseInputDate(newDate);
        // debounced
        this.startDate = this.sdInput;
      },
    },
    startTimeInput: {
      get() {
        return this.st;
      },
      set: function(newTime) {
        // Controllo che sia nel formato giusto
        this.stInput = this.$anm22.parseInputTime(newTime);
        this.startTime = this.stInput;
      },
    },
    endDate: {
      get() {
        return this.ed;
      },
      set: function(newDate) {
        this.ed = newDate;
        this.checkInputFields("e");
      },
    },
    endTime: {
      get() {
        return this.et;
      },
      set: _.debounce(function(newTime) {
        this.et = newTime;
        this.checkInputFields("e");
      }, 100),
    },
    endDateInput: {
      get() {
        return this.ed;
      },
      set: function(newDate) {
        // Controllo che sia nel formato giusto
        this.edInput = this.$anm22.parseInputDate(newDate);
        this.endDate = this.edInput;
      },
    },
    endTimeInput: {
      get() {
        return this.et;
      },
      set: function(newTime) {
        // Controllo che sia nel formato giusto
        this.etInput = this.$anm22.parseInputTime(newTime);
        this.endTime = this.etInput;
      },
    },
    kilometers: {
      get() {
        if (this.additionalData && this.additionalData.kilometers) {
          return this.additionalData.kilometers;
        } else {
          return 0;
        }
      },
      set(newVal) {
        this.$set(this.additionalData, "kilometers", newVal);
      },
    },
    timezoneArrival: {
      get() {
        if (this.additionalData && this.additionalData.timezoneArrival) {
          return this.additionalData.timezoneArrival;
        } else {
          return this.event.timezone;
        }
      },
      set(newVal) {
        this.$set(this.additionalData, "timezoneArrival", newVal);
      },
    },
  },
  methods: {
    checkInputFields(input) {
      delete this.errors["end"];
      delete this.errors["start"];
      const start = this.$moment(this.sd + " " + this.st);
      const end = this.$moment(this.ed + " " + this.et);
      if (!start.isValid()) {
        this.$set(this.errors, "start", { text: "" });
        return;
      }
      if (!end.isValid()) {
        this.$set(this.errors, "end", { text: "" });
        return;
      }
      if (end.unix() < start.unix()) {
        if (input === "f") {
          this.$set(this.errors, "start", { text: "" });
          //   this.ed = this.edInput = this.sd;
          //   this.et = this.etInput = this.st;
        } else {
          this.$set(this.errors, "end", { text: "" });
          //   this.sd = this.sdInput = this.ed;
          //   this.st = this.stInput = this.et;
        }
      }
    },
    setDate(newDate) {
      if (this.isFrom) {
        this.sdInput = this.$anm22.parseInputDate(newDate);
        this.startDate = this.sdInput;
      } else {
        this.edInput = this.$anm22.parseInputDate(newDate);
        this.endDate = this.edInput;
      }
      this.openPicker = false;
    },
    // dateInputParser(newDate) {
    //   const tokens = newDate.replace('/', '-').split('-');
    //   return tokens.map(t => t.padStart(2, '0')).join('-');
    // },
    // timeInputParser(newTime) {
    //   const tokens = newTime.replace(/[.,;]/i, ':').split(':');
    //   return tokens.map(t => t.padStart(2, '0')).join(':');
    // },
    saveEvent() {
      // Controllo immediatamente le date
      this.sd = this.sdInput || this.sd;
      this.st = this.stInput || this.st;
      this.ed = this.edInput || this.ed;
      this.et = this.etInput || this.et;
      this.checkInputFields("f");
      if (Object.keys(this.errors).length > 0) {
        return;
      }
      // Collego timezone e date
      this.event.startTimestamp = this.$moment
        .tz(this.sd + " " + this.st, this.event.timezone)
        .unix();
      this.event.endTimestamp = this.$moment
        .tz(this.ed + " " + this.et, this.timezoneArrival)
        .unix();
      // Set additional data
      this.event.jsonData = JSON.stringify(this.additionalData);
      let add = false;
      if (!this.event.idWorldEvent) {
        add = true;
        this.event.dbKey = this.event.idWorldEvent = this.$anm22.genLocalId();
      }
      // Gestisco flag richiesta cancellazione tracking tempo
      if (this.event.tempTimeTracking) {
        this.removeTempTimeTracking = true;
        delete this.event.tempTimeTracking;
      } else {
        this.removeTempTimeTracking = false;
      }
      this.$http
        .post(
          "event/save",
          {
            projectId: this.projectId,
            event: this.event,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          //Salvo in db locale i nuovi dati
          let project = this.$store.getters["projects/get"](this.projectId);
          if (add) {
            project.events.push(response.data.event.idWorldEvent);
          }
          return Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: [response.data.event],
            }),
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: [project],
            }),
          ]);
        })
        .then(() => {
          // Cancello monitoraggio in corso
          if (this.removeTempTimeTracking) {
            this.$store.commit("headbar/runningTask", null);
            this.$anm22.setCookie("tk_r_t", null, 1);
          }
          this.$anm22.eventBus.$emit("wg-modal-close");
        })
        .catch((error) => {
          const project = this.$store.getters["projects/get"](this.projectId);
          if (add) {
            project.events.push(this.event.idWorldEvent);
          }
          Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: [this.event],
            }),
            this.$store.dispatch("offline/saveSyncTuple", {
              _vue: this,
              _class: "WorldEvent",
              _table: "events",
              mode: add ? "new" : "edit",
              type: "obj",
              obj: this.event,
            }),
            // this.$anm22.saveSyncTuple(
            //   this,
            //   "WorldEvent",
            //   add ? 'new' : 'edit',
            //   this.event
            // ),
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: [project],
            }),
            this.$store.dispatch("offline/saveSyncTuple", {
              _vue: this,
              _class: "WorldProject",
              _table: "projects",
              mode: "edit",
              type: "obj",
              obj: project,
            }),
            // this.$anm22.saveSyncTuple(
            //   this,
            //   "WorldProject",
            //   'edit',
            //   project
            // )
          ])
            .then((result) => {
              this.$anm22.eventBus.$emit("wg-modal-close");
            })
            .catch((error) => {
              console.log(error);
            });
        });
    },
  },
  components: {
    WorldDatePicker,
  },
  created() {
    this.sd = this.sdInput = this.$moment
      .unix(this.event.startTimestamp)
      .tz(this.event.timezone)
      .format("YYYY-MM-DD");
    this.st = this.stInput = this.$moment
      .unix(this.event.startTimestamp)
      .tz(this.event.timezone)
      .format("HH:mm");
    let timezone = this.event.timezone;
    if (this.additionalData && this.additionalData.timezoneArrival) {
      timezone = this.additionalData.timezoneArrival;
    }
    this.ed = this.edInput = this.$moment
      .unix(this.event.endTimestamp)
      .tz(timezone)
      .format("YYYY-MM-DD");
    this.et = this.etInput = this.$moment
      .unix(this.event.endTimestamp)
      .tz(timezone)
      .format("HH:mm");
  },
};
</script>

<style lang="scss" scoped>
.button-disabled {
  opacity: 0.4;
  pointer-events: none;
}
.input-date-picker-label {
  width: 100%;
  max-width: 300px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 4px;
  display: block;
  box-shadow: none;
  background-color: #eee;
  border: 1px solid #eee;
  height: 36px;
  font-size: 12px;
  cursor: pointer;
}
.input-error {
  border: 1px solid #ff5252;
  background-color: #ff5252;
}
</style>
